export const environment = {
  production: false,
  apiUrl: 'https://bo.im.suntelecoms.com/api/',
  adminAppUrl:'https://bo.ig.suntelecoms.com/',
  apgUrl:'',
  cinetpayUrl:'',
  assuranceApiUrl : '',
  appName: '',
  appHost: '',
};

